import './SignalStageOsd.sass'
import { TbAlertTriangleFilled, TbArrowBarToRight, TbArrowBarToUp, TbGridScan } from 'react-icons/tb'
import OsdFloatBox from '../../OsdFloatBox/OsdFloatBox'
import { useDispatch } from 'react-redux'
import useDeviceTelemetries from 'src/services/device/common/useDeviceTelemetries'
import { useMemo } from 'react';

function SignalStageOsd({ entity, style }) {
  const dispatch = useDispatch();
  const telemetries = useDeviceTelemetries(entity?.id);
  const sdrSignal = telemetries?.wireless_link?.sdr_quality * 20;
  
  const error = useMemo(() => {
    if(!sdrSignal) return false;

    if (sdrSignal < 30) {
      return {
        title: 'Critical weak SDR signal detected',
        description: 'Your SDR signal is below 30%. Your connection may be unstable. Please move the device closer to the Dock.',
        counterValue: `${sdrSignal}%`,
        counterColor: 'red',
      }
    } else if (sdrSignal < 50) {
      return {
        title: 'Weak SDR signal detected',
        description: 'Your SDR signal is below 50%. Please consider moving the device closer to the Dock to prevent performance issues.',
        counterValue: `${sdrSignal}%`,
        counterColor: 'orange',
      }
    }

    return false;
  }, [telemetries]);

  return !error ? null : (
    <OsdFloatBox title={error.title} icon={TbAlertTriangleFilled} counter={error.counterValue} counterColor={error.counterColor} style={style} collapsable>
      <div className="signal-stage-osd">
        {error.description}
      </div>
    </OsdFloatBox>
  )
}

export default SignalStageOsd